import styled from 'styled-components';

export const Label = styled.label`
  display: flex;
  align-items: start;
  width: 100%;
`;

export const Check = styled.input.attrs({
  type: 'checkbox',
})`
  appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #005f47;
  border-radius: 4px;
  background: none;
  cursor: pointer;
  position: relative;
  transition: border-color 0.2s;
  margin: 0;

  &:checked {
    background: #005f47;
    border-color: #005f47;
  }

  &:checked::after {
    content: '';
    display: block;
    position: absolute;
    left: 4px;
    top: 1px;
    width: 5px;
    height: 8px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;
